import CustomFilters from './filters';
import SliderFilter from "./SliderFilter";

class Product {
	constructor() {
		if ($('[package="cms-product"]').length < 1) {
			return;
		}

		new SliderFilter();

		this.filters = new CustomFilters();
	}
}
export default new Product();